{
  "adobeBrandType": "cloud",
  "appId": "landing",
  "name": "Experience Cloud",
  "longName": "Adobe Experience Cloud",
  "path": "/home",
  "direct": "true"
}
